module.exports = __webpack_public_path__ + "static/media/juize-chain.46aeebf6.png";